import React                from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useTranslation }   from 'react-i18next';
import Box                  from '@material-ui/core/Box';
import Link                 from './Link';

const SolutionsForThem = () => {
	const { t } = useTranslation();
	return (
		<Grid container spacing={1} direction='column'>
			<Grid item xs={12}>
				<Box my={2}>
					<Typography variant='h4'>{t('footer_nav_why_shells_header_2')}</Typography>
				</Box>
			</Grid>
			<Grid item xs={12}>
				<Link href={`${process.env.REACT_APP_SHELL_URL}/lp/rif`}>
					{t('footer_nav_solutions_for_business_t9')}
				</Link>
			</Grid>
			<Grid item xs={12}>
				<Link href={`${process.env.REACT_APP_SHELL_URL}/lp/byod`}>
					{t('footer_nav_solutions_for_business_t18')}
				</Link>
			</Grid>
			<Grid item xs={12}>
				<Link href={`${process.env.REACT_APP_SHELL_URL}/lp/simplified`}>
					{t('footer_nav_solutions_for_business_t19')}
				</Link>
			</Grid>
		</Grid>
	);
};

export default SolutionsForThem;